import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App.tsx";
import { EventsProvider } from "./lib/events.tsx";
import { ToastProvider } from "./lib/toast.tsx";
import "./index.css";

/**
 * Canlı olaylar WebSocket'ten geldiği için sorgu tarafında agresif polling'e gerek
 * yok; sadece pencereye dönüldüğünde tazeleniyor.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 10_000, refetchOnWindowFocus: true, retry: 1 },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <EventsProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </EventsProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
